import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComponent = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M18.875 9.811a9.063 9.063 0 1 1-18.126.002 9.063 9.063 0 0 1 18.126-.002Z",
			stroke: "#262626",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5,
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.25 9.749h9m-4.5 4.5v-9m6.471 10.97 7.029 7.03",
			stroke: "#262626",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		})
	]
});
export const ReactComponent = SvgComponent;
export default "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22none%22%20viewBox%3D%220%200%2024%2024%22%3E%3Cpath%20d%3D%22M18.875%209.811a9.063%209.063%200%201%201-18.126.002%209.063%209.063%200%200%201%2018.126-.002Z%22%20stroke%3D%22%23262626%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke-width%3D%221.5%22%20clip-rule%3D%22evenodd%22%2F%3E%3Cpath%20d%3D%22M5.25%209.749h9m-4.5%204.5v-9m6.471%2010.97%207.029%207.03%22%20stroke%3D%22%23262626%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke-width%3D%221.5%22%2F%3E%3C%2Fsvg%3E";
